export default "__VITE_ASSET__BjTMtWra__"